import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, Self } from '@angular/core';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';

import { SectionLoadingDirective } from '@domgen/dgx-fe-components/loading';
import { RegistrationWarrantyNotePanelComponent } from '@us-registration/feature-components';
import {
  RegistrationConfirmationApplianceDetailsPanelComponent,
  RegistrationConfirmationCPGPanelComponent,
  RegistrationConfirmationPlanDetailsPanelComponent,
} from '@us-registration/ui-components';
import { USPostHogTrackingEvents } from '@us-registration/util-models';
import posthog from 'posthog-js';
import { RegistrationOrderConfirmationWibComponentService } from '../../services/registration-order-confirmation-wib-component.service';

@Component({
  selector: 'us-registration-registration-order-confirmation-wib',
  standalone: true,
  imports: [
    AsyncPipe,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgFor,
    NgIf,
    RegistrationConfirmationApplianceDetailsPanelComponent,
    RegistrationConfirmationCPGPanelComponent,
    RegistrationConfirmationPlanDetailsPanelComponent,
    RegistrationWarrantyNotePanelComponent,
    SectionLoadingDirective,
  ],
  providers: [RegistrationOrderConfirmationWibComponentService],
  templateUrl: './registration-order-confirmation-wib.component.html',
  styleUrls: ['./registration-order-confirmation-wib.component.scss'],
})
export class RegistrationOrderConfirmationWibComponent {
  constructor(
    @Self() readonly cs: RegistrationOrderConfirmationWibComponentService
  ) {
    posthog.capture(
      USPostHogTrackingEvents.RegistrationOrderConfirmationLoaded
    );
  }
}
